import { useTranslation } from "react-i18next";

import { LANGUAGES } from "../i18n";
import { isAuthenticated, saveMyLanguage } from "../services/authService";

export default function LanguageSwitcher({ compact = false }) {
  const { i18n, t } = useTranslation();
  const current = LANGUAGES[i18n.language] ? i18n.language : "en";

  // Two languages, so a single toggle is clearer than a dropdown.
  const other = current === "en" ? "ar" : "en";

  return (
    <button
      type="button"
      onClick={() => {
        i18n.changeLanguage(other);
        // Signed in: remember it, so the next login opens in this language.
        // Best effort — the switch itself never waits on the network.
        if (isAuthenticated()) saveMyLanguage(other).catch(() => {});
      }}
      aria-label={t("app.language")}
      title={t("app.language")}
      className={`rounded-md border border-line-strong font-semibold text-ink transition hover:bg-raised ${
        compact ? "px-2 py-1 text-xs" : "w-full px-3 py-2 text-sm"
      }`}
    >
      {LANGUAGES[other].label}
    </button>
  );
}
